import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import './StudentPages.css';

const StudentTests = () => {
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState('pending');
  const [msg, setMsg] = useState('');

  useEffect(() => { fetchTests(); }, []);

  const fetchTests = async () => {
    try {
      const res = await API.get('/portal/tests');
      setTests(res.data || []);
    } catch (err) {
      console.error('fetchTests error:', err);
    } finally {
      setLoading(false);
    }
  };

  const pending   = tests.filter(t => t.attempt_status === 'in_progress' || t.attempt_status === 'not_started');
  const completed = tests.filter(t => t.attempt_status === 'submitted');

  const getScoreColor = (score, total) => {
    if (!total) return '#888';
    const p = (score / total) * 100;
    return p >= 80 ? '#16a085' : p >= 60 ? '#f39c12' : '#e94560';
  };

  if (loading) return <div className="s-loading">Loading...</div>;

  const sections = [
    { key: 'pending',   label: '⏳ Pending',   count: pending.length,   color: '#0f3460' },
    { key: 'completed', label: '✓ Completed',  count: completed.length, color: '#16a085' },
  ];

  return (
    <div className="tests-page-content">
      <div className="s-page-header">
        <h2>My Tests</h2>
        <p>Track your assigned and completed tests</p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {sections.map(s => (
          <button key={s.key}
            onClick={() => setActiveSection(s.key)}
            style={{
              padding: '9px 20px', borderRadius: 8, fontSize: 13, fontWeight: 500,
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
              border: `1.5px solid ${activeSection === s.key ? s.color : '#e0e0e0'}`,
              background: activeSection === s.key ? s.color : 'white',
              color: activeSection === s.key ? 'white' : '#888',
            }}>
            {s.label}
            <span style={{
              background: activeSection === s.key ? 'rgba(255,255,255,0.25)' : '#f0f0f0',
              padding: '1px 8px', borderRadius: 20, fontSize: 11, fontWeight: 700,
            }}>{s.count}</span>
          </button>
        ))}
      </div>

      {activeSection === 'pending' && (
        pending.length === 0 ? <div className="s-empty">No pending tests.</div> : (
          <div className="s-test-grid">
            {pending.map((t, i) => (
              <div key={i} className="s-test-card">
                <div className="s-test-type">{t.test_type}</div>
                <div className="s-test-name">{t.test_name}</div>
                <div className="s-test-meta">⏱ {t.duration_minutes} mins · 📝 {t.total_marks} marks</div>
                <button className="s-btn-start" onClick={() => navigate(`/student/test/${t.id}`)}>Start Test →</button>
              </div>
            ))}
          </div>
        )
      )}

      {activeSection === 'completed' && (
        completed.length === 0 ? <div className="s-empty">No completed tests yet.</div> : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {completed.map((t, i) => {
              const pct = t.total_marks > 0 ? ((t.score / t.total_marks) * 100).toFixed(1) : null;
              const color = getScoreColor(t.score, t.total_marks);
              return (
                <div key={i} className="s-test-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ flex: 1 }}>
                    <div className="s-test-name">{t.test_name}</div>
                    <div className="s-test-meta">Score: <strong style={{color}}>{t.score} / {t.total_marks} ({pct}%)</strong></div>
                    <div className="s-test-meta" style={{ marginTop: 5, fontSize: 12, color: '#666' }}>
                      ✓ Correct: <strong style={{color: '#16a085'}}>{t.correct || 0}</strong> | 
                      ✗ Wrong: <strong style={{color: '#e74c3c'}}>{t.wrong || 0}</strong> | 
                      ⊘ Skipped: <strong style={{color: '#95a5a6'}}>{t.unattempted || 0}</strong>
                    </div>
                  </div>
                  <button className="s-btn-start" style={{width: 'auto', padding: '8px 16px'}} onClick={() => navigate(`/student/test/${t.id}/results`)}>View Report</button>
                </div>
              );
            })}
          </div>
        )
      )}
    </div>
  );
};

export default StudentTests;
